import React, { useEffect } from 'react';
import { SignUp as ClerkSignUp, useUser } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import '../styles/AuthPages.css';
import { GreatLeapLogoIcon } from '../components/GreatLeapLogoIcon';

export default function SignUp() {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useUser();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      navigate('/dashboard', { replace: true });
    }
  }, [isSignedIn, isLoaded, navigate]);

  return (
    <div className="auth-container">
      {/* Left Side - Brand */}
      <div className="auth-left-side">
        {/* Glowing wave SVG overlay */}
        <svg className="auth-waves" viewBox="0 0 500 700" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
          <defs>
            <linearGradient id="wg1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#00c8dc" stopOpacity="0.0"/>
              <stop offset="40%" stopColor="#00c8dc" stopOpacity="0.7"/>
              <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2"/>
            </linearGradient>
            <linearGradient id="wg2" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.0"/>
              <stop offset="50%" stopColor="#22d3ee" stopOpacity="0.45"/>
              <stop offset="100%" stopColor="#60a5fa" stopOpacity="0.1"/>
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2.5" result="coloredBlur"/>
              <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
            </filter>
          </defs>
          <path d="M-20 480 Q80 420 160 450 Q260 490 360 430 Q430 400 520 420" fill="none" stroke="url(#wg1)" strokeWidth="2" filter="url(#glow)"/>
          <path d="M-20 510 Q90 450 180 480 Q280 520 380 460 Q450 430 520 455" fill="none" stroke="url(#wg1)" strokeWidth="1.5" opacity="0.6"/>
          <path d="M-20 540 Q100 480 190 510 Q300 545 400 490 Q460 460 520 480" fill="none" stroke="url(#wg2)" strokeWidth="1" opacity="0.4"/>
          <path d="M-20 560 Q110 500 200 530 Q310 565 410 510 Q470 480 520 500" fill="none" stroke="url(#wg2)" strokeWidth="0.8" opacity="0.3"/>
          <circle cx="80"  cy="455" r="2.5" fill="#00c8dc" opacity="0.8" filter="url(#glow)"/>
          <circle cx="155" cy="443" r="1.8" fill="#22d3ee" opacity="0.65"/>
          <circle cx="240" cy="462" r="2.2" fill="#00c8dc" opacity="0.7" filter="url(#glow)"/>
          <circle cx="325" cy="438" r="1.5" fill="#60a5fa" opacity="0.55"/>
          <circle cx="395" cy="424" r="2"   fill="#22d3ee" opacity="0.6" filter="url(#glow)"/>
          <circle cx="460" cy="418" r="1.5" fill="#0ea5e9" opacity="0.5"/>
          <circle cx="110" cy="508" r="1.5" fill="#22d3ee" opacity="0.5"/>
          <circle cx="210" cy="490" r="2"   fill="#00c8dc" opacity="0.45"/>
          <circle cx="300" cy="515" r="1.5" fill="#60a5fa" opacity="0.4"/>
          <circle cx="420" cy="495" r="2"   fill="#22d3ee" opacity="0.5" filter="url(#glow)"/>
          <circle cx="430" cy="80"  r="60"  fill="#1e40af" opacity="0.08"/>
          <circle cx="460" cy="60"  r="30"  fill="#3b82f6" opacity="0.06"/>
        </svg>

        <div className="auth-left-content">
          <div className="auth-brand-logo">
            <GreatLeapLogoIcon size={105} variant="dark" />
          </div>

          <div className="auth-motivational">
            <strong>Start Your <span className="accent-green">Journey</span></strong>
            <p>Transform your ideas into reality.<br />Powerful tools designed for ambitious teams.</p>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="auth-right-side">
        <div className="auth-right-inner">
          {/* Avatar icon */}
          <div className="auth-avatar">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <line x1="19" y1="8" x2="19" y2="14"/>
              <line x1="22" y1="11" x2="16" y2="11"/>
            </svg>
          </div>

          {/* Header above the clerk card */}
          <div className="auth-header">
            <h1>Create Account</h1>
            <p>Join us today and get started</p>
          </div>

          {/* Clerk sign-up card */}
          <div className="auth-clerk-wrap">
            <ClerkSignUp
              signInUrl="/signin"
              fallbackRedirectUrl="/dashboard"
              routing="virtual"
            />
          </div>

          <div className="auth-footer">
            <p>
              Already have an account?{' '}
              <button onClick={() => navigate('/signin')} className="link-button">
                Sign In
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
